import { render, staticRenderFns } from "./vistaNoEncontrada.vue?vue&type=template&id=7f90d16e&scoped=true&"
var script = {}
import style0 from "./vistaNoEncontrada.vue?vue&type=style&index=0&id=7f90d16e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f90d16e",
  null
  
)

export default component.exports